import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NumberInput, QuantityControl } from "../Form/NumberInput";
import CustomButton from "../Form/CustomButton";
import { useCart } from "../../context/cart-context";
import ActionModal from "../global/ActionModal";

import { ReactComponent as CartIcon } from "../../static/svg/cart.svg";

import { ReactComponent as WhatsappIcon } from "../../static/svg/socials/whatsapp.svg";

export const ViewProductDetails = ({ data }) => {
  const [show, setShow] = React.useState(false);

  const [qty, setQty] = React.useState(1);
  const { cart, addToCart } = useCart();
  let navigate = useNavigate();

  // console.log(data);

  // console.log("data", data);
  let userNumber = 447936794742;
  let message = `Hello *Strandz By Dee*,

I saw this product on your website https://strandzbydee.co.uk, and I'd like to make a purchase:

Product: *${data.name}*  
Color: *${data.color}*  
Price: *£ ${data.price}*  
Url: https://strandzbydee.co.uk/shop/view/${data.slug}/${data.id}  

Please let me know how to proceed. Thank you!`;

  const handleAddProduct = (e) => {
    e.preventDefault();

    // Assuming data.name is the unique identifier for your products
    const isProductAlreadyAdded = cart.some(
      (product) => product.id === data.id
    );

    if (isProductAlreadyAdded) {
      // console.log(`Already added ${data.name}`);
      toast(`Already added ${data.name}`, {
        type: "error",
      });
    } else {
      addToCart(
        data.id,
        data.imgSrc,
        data.name,
        data.slug,
        Number(data.price),
        Number(qty),
        Number(data.limit)
        // "teloyeleye@gmail.com"
      );
      setShow(true);
      setQty(1);
      toast(`${data.name} added to cart`, {
        type: "success",
      });
    }
  };

  // React.useEffect(() => {
  //   console.log("cart", cart);
  // }, [cart, data]);
  return (
    <React.Fragment>
      <ToastContainer />

      {data && (
        <Box className=" md:p-4 grid">
          <Typography
            variant="h3"
            // fontWeight={900}
            fontSize={{ xs: "25px", sm: "30px", md: "40px" }}
            lineHeight={{ xs: "103%", sm: "105.5%" }}
            letterSpacing={"0.1rem"}
            color="primary"
            className=" pb-3"
          >
            {/* Brazilian Hair Esprezo */}
            {data.name}
          </Typography>

          <Typography
            variant="caption"
            fontSize={{ xs: "18px", sm: "20px", md: "25px" }}
            lineHeight={{ xs: "185%", sm: "180%" }}
            letterSpacing={"-0.05em"}
            color={"secondary.light"}
            className=""
          >
            £{data.price}
          </Typography>

          <Typography
            variant="body"
            fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
            lineHeight={{ xs: "185%", sm: "180%" }}
            letterSpacing={"-0.02em"}
            color={"primary"}
            className=" w-full md:w-[80%] md:mx-auto opacity-60 py-6"
          >
            {data.description}
          </Typography>

          <Box className=" py-4 flex gap-4">
            <Box className=" w-fit">
              <QuantityControl
                value={qty}
                min={1}
                max={data.limit}
                onChange={setQty}
              />
            </Box>

            <CustomButton
              type="submit"
              // form="add-member-form"
              //   loading={true}
              sx={{ width: "170px", height: "55px" }}
              color="primary"
              className="text-sm !uppercase"
              onClick={handleAddProduct}
              // fullWidth
            >
              Add to cart
              <CartIcon className=" h-5 w-5 ml-1" />
            </CustomButton>
            {/* <a
              href={`https://wa.me/${userNumber}?text=${encodeURIComponent(
                message
              )}`}
              className=" mt-10"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CustomButton
                type="submit"
                // form="add-member-form"
                //   loading={true}
                sx={{ width: "150px", height: "55px" }}
                color="primary"
                className="text-sm !uppercase"
                // onClick={handleAddProduct}
                // fullWidth
              >
                Purchase
                <WhatsappIcon className=" h-5 w-5 ml-1" />
              </CustomButton>
            </a> */}
          </Box>
          <Box className=" flex pt-2 gap-2">
            <Typography
              variant="body"
              fontSize={{ xs: "16px", sm: "16px", md: "16px" }}
              lineHeight={{ xs: "185%", sm: "180%" }}
              letterSpacing={"-0.02em"}
              color={"primary"}
              className="  md:mx-auto opacity-90 line-clamp-1"
            >
              Categories:
            </Typography>
            <Typography
              variant="body"
              fontSize={{ xs: "16px", sm: "16px", md: "16px" }}
              lineHeight={{ xs: "185%", sm: "180%" }}
              letterSpacing={"-0.02em"}
              color={"primary"}
              className="  md:mx-auto opacity-60 line-clamp-1"
            >
              {/* Short, Long, Braids, Weavon */}
              {data.categories}
            </Typography>
          </Box>

          <Box className=" flex gap-2">
            <Typography
              variant="body"
              fontSize={{ xs: "16px", sm: "16px", md: "16px" }}
              lineHeight={{ xs: "185%", sm: "180%" }}
              letterSpacing={"-0.02em"}
              color={"primary"}
              className="  md:mx-auto opacity-90 line-clamp-1"
            >
              Color:
            </Typography>
            <Typography
              variant="body"
              fontSize={{ xs: "16px", sm: "16px", md: "16px" }}
              lineHeight={{ xs: "185%", sm: "180%" }}
              letterSpacing={"-0.02em"}
              color={"primary"}
              className="  md:mx-auto opacity-60 line-clamp-1"
            >
              {data.color}
            </Typography>
          </Box>
        </Box>
      )}

      {show && (
        <ActionModal
          statement={"Do you wish to continue shopping?"}
          label1={"Continue"}
          label2={"View Cart"}
          modalstate={show}
          closeModal={() => navigate("/cart")}
          handleDelete={(e) => setShow(false)}
        />
      )}
    </React.Fragment>
  );
};
